import { PlanType } from 'api/billings/dtos'
import { TransactionType } from 'api/transactions/dtos'
import { IUserDto, IUserInviteDto } from './dtos'

export enum SupportedJurisdictions {
	USA = 'USA',
	CA = 'CA',
	UK = 'UK',
	SA = 'SA',
}

export interface IUser extends Pick<IUserDto, 'firstName' | 'lastName' | 'email' | 'costBasisMethod' | 'referral'> {
	id: string
	currentPlan: PlanType
	subscribedPlan?: PlanType
	fullName: string
	isCPA: boolean
	usedAnalyzeCount: number
	maxAnalyzeCount: number
	maxTransactions: number
	jurisdiction: SupportedJurisdictions
	properties?: Record<string, string>
	orgId?: IUserDto['organizationId']
	paidUntil?: Date
	hasCustomerId: boolean
	externalProvider?: {
		type: 'WEALTHICA'
		userId: string
	}
}

export interface IUserInvite extends Pick<IUserInviteDto, 'email' | 'retries' | 'status' | 'sender' | 'id'> {
	resentRecently: boolean
}

export interface IJurisdiction {
	costBasisMethods: {
		isAllowed: boolean
		name: string
	}[]
	currency: string
	fullName: string
	shortName: SupportedJurisdictions
}

export interface IJurisdictionProperties {
	transcaction: Partial<Record<TransactionType, Record<string, string[]>>>
	user: Record<string, string[]>
	wallet: Record<string, string[]>
}

export interface IFeatureAccess {
	download?: string
	reviewTransactions?: string
	addTransaction?: string
	editTransaction?: string
	deleteTransaction?: string
	deleteAllTransactions?: string
	deleteIntegration?: string
	deleteAllIntegrations?: string
	import?: string
	generateReport?: string
	taxAnalysis?: string
	transferMapping?: string
	recalculate?: string
}

export interface ITutotialStatus {
	reports: boolean
	transactions: boolean
	imports: boolean
}

export interface IWealthicaCredentials {
	email: string
	token: string
}
